// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export default class RoundedButton extends Vue {
  @Prop()
  public icon!: string;

  @Prop()
  public closeButton?: boolean;

  @Prop({ default: false })
  public themeDark?: boolean;

  @Prop({ default: false })
  public small?: boolean;

  created() {}

  handleClick() {
    this.$emit("click", false);
  }
}
